import { ReactElement, ReactNode, useEffect } from 'react';
import { useAuthContext } from './AuthProvider';
import { DNA } from './DNA';

export function RequireAuth(props: { children: ReactNode }): ReactElement {
  const { user, error, isLoading } = useAuthContext();
  useEffect(() => {
    if (!user && !error && !isLoading) {
      window.location.href = `${
        import.meta.env.VITE_LOGIN_URL as string
      }?redirect=${encodeURIComponent(window.location.href)}`;
    }
  }, [user, isLoading]);

  if (user) {
    return <>{props.children}</>;
  }

  return <DNA />;
}
